import React, { useState, useEffect, useMemo, useRef } from 'react';
import Divider from '@mui/material/Divider';
import TR from './../../Trans';
import Grid from '@mui/material/Grid';
import { checkIfMobile } from '../../services/screen';
import Waiting from './../items/Waiting';
import IconButton from '@mui/material/IconButton';
import IntervalService from './../../services/intervals';
import AddPlayList from './../dialogs/AddPlayList';
import ContentContainer from './../items/ContentContainer';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteDialog from './../dialogs/DeleteDialog';
import ChangePlayList from './../dialogs/ChangePlayList';
import muvikaAttrs from './../../attrs';
import Confirm from './../dialogs/Confirm';
import SaveIcon from '@mui/icons-material/Save';
import { useMediaQuery } from 'react-responsive';
import SavePlayList from './../dialogs/SavePlayList';
import EditPlayList from './../dialogs/EditPlayList';
import PlayListListItem from './../items/PlayListListItem';
import sessionStore from './../../stores/session';
import settingsStore from '../../stores/settings';
import performanceStore from './../../stores/performance';
import playerStore from './../../stores/player';
import messageStore from './../../stores/message';
import favoritesStore from '../../stores/favorites';
import accountStore from '../../stores/account';

function PlayLists() {

  const [scrollTop, setScrollTop] = useState(() => {
    const savedScrollTop = sessionStorage.getItem(muvikaAttrs.service + "-playlists-scrolltop");
    const initialValue = JSON.parse(savedScrollTop);
    return initialValue || "";
  });

  const [isAddPlayListOpen, setIsAddPlayListOpen] = useState(false);
  const [isSavePlayQueueOpen, setIsSavePlayQueueOpen] = useState(false);
  const [isSavePlayListOpen, setIsSavePlayListOpen] = useState(false);
  const [isEditPlayListOpen, setIsEditPlayListOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isChangePlayListOpen, setIsChangePlayListOpen] = useState(false);

  const [chosenPlayList, setChosenPlayList] = useState(null);
  const [isDialogClosing, setIsDialogClosing] = useState(false);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const isSet = performanceStore((state) => state.isSet);
  const isWaiting = performanceStore((state) => state.isWaiting);
  const playLists = performanceStore((state) => state.playLists);
  const setPlayList = performanceStore((state) => state.setPlayList);
  const getPlayLists = performanceStore((state) => state.getPlayLists);
  const createPlayList = performanceStore((state) => state.createPlayList);
  const deletePlayList = performanceStore((state) => state.deletePlayList);
  const playQueue = performanceStore((state) => state.playQueue);
  const setCurrentPlayList = performanceStore((state) => state.setCurrentPlayList);
  const savePlayQueue = performanceStore((state) => state.savePlayQueue);
  const savePlayList = performanceStore((state) => state.savePlayList);
  const changePlayListName = performanceStore((state) => state.changePlayListName);
  const emptyPlayer = playerStore((state) => state.empty);
  const setPlayIsOn = performanceStore((state) => state.setPlayIsOn);
  const clearCurrentPlayList = performanceStore((state) => state.clearCurrentPlayList);
  const addPlayListToTheEnd = performanceStore((state) => state.addPlayListToTheEnd);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const favorites = favoritesStore((state) => state.tracks);
  const setError = messageStore((state) => state.setError);
  const settingsUsageMode = settingsStore((state) => state.settings?.usage_mode);
  const accountLang = accountStore((state) => state.account?.language);

  useEffect(() => {}, [accountLang]);

  const playlistsRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      console.log("clicked");
      if (playlistsRef.current && !playlistsRef.current.contains(event.target)) {
        console.log("clicked away");
        setIsDialogClosing(true);
        setTimeout(() => scrollToPos(), 100);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const scrollToPos = () => {
    console.log("scrollToPos");
    let containerElement = document.getElementById("muvika-playlists");
    const savedScrollTop = sessionStorage.getItem(muvikaAttrs.service + "-playlists-scrolltop");
    const initialValue = JSON.parse(savedScrollTop);
    let scrollTop = initialValue || null;
    if (containerElement && scrollTop) {
      containerElement.scrollTop = scrollTop;
    }
  };

  useEffect(() => {
    if (!playLists) {
      getPlayLists(sessionToken);
    }
    scrollToPos();
  }, []);

  const handleOpenAddPlayList = () => {
    setIsAddPlayListOpen(true);
  };

  const handleCloseAddPlayList = () => {
    setIsAddPlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleOpenSavePlayQueue = () => {
    setIsSavePlayQueueOpen(true);
  };

  const handleCloseSavePlayQueue = () => {
    setIsSavePlayQueueOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleOpenSavePlayList = () => {
    setIsSavePlayListOpen(true);
  };

  const handleOpenChangePlayList = () => {
    setIsChangePlayListOpen(true);
  };

  const handleCloseSavePlayList = () => {
    setIsSavePlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleOpenEditPlayList = () => {
    setIsEditPlayListOpen(true);
  };

  const handleCloseEditPlayList = () => {
    setIsEditPlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleCloseChangePlayList = () => {
    setIsChangePlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleConfirmation = () => {
    savePlayList(sessionToken, chosenPlayList.id, chosenPlayList.name);
    setIsSavePlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleDeletion = () => {
    if (chosenPlayList) {
      deletePlayList(sessionToken, chosenPlayList.id);
    }
    setIsDeleteDialogOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handlePlayListCreation = (playListName) => {
    if (playListName.length > 0) {
      createPlayList(sessionToken, playListName);
      setIsAddPlayListOpen(false);
      setTimeout(() => scrollToPos(), 100);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const handlePlayQueueSave = (playListName) => {
    if (playListName.length > 0) {
      savePlayQueue(sessionToken, playListName);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
    setIsSavePlayQueueOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handlePlayListEdit = (playListName) => {
    if (chosenPlayList && playListName.length > 0) {
      changePlayListName(sessionToken, playListName, chosenPlayList);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
    setIsEditPlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const playListList = useMemo(() => {
    if (playLists) {
      console.log("render again lists");
      const savedOpenPlayLists = sessionStorage.getItem(muvikaAttrs.service + "-playlists-opened");
      const initialValue = JSON.parse(savedOpenPlayLists);
      let openPlayLists = initialValue || [];
      return playLists.map((playList, index) =>
        <PlayListListItem
          key={playList.id}
          open={openPlayLists.includes(playList.id)}
          onEditPerformanceClose={() => {
            setIsDialogClosing(true);
            setTimeout(() => scrollToPos(), 100);
          }}
          id={playList.id}
          playList={playList}
          type={playList.type}
          performances={playList.items}
          favorites={favorites}
          name={playList.name}
          created={playList.created}
          onSetCurrentPlayList={(e) => {

            e.stopPropagation();
            setChosenPlayList(playList);
            handleOpenChangePlayList();
          }}
          onOpenEditDialog={(e) => {

            e.stopPropagation();
            setChosenPlayList(playList);
            handleOpenEditPlayList();
          }}
          onOpenDeleteDialog={(e) => {

            e.stopPropagation();
            setChosenPlayList(playList);
            handleOpenDeleteDialog();
          }}
          onOpenSavePlayListDialog={(e) => {

            e.stopPropagation();
            setChosenPlayList(playList);
            handleOpenSavePlayList();
          }}
        />
      );
    }
  }, [playLists]);

  const waitingRender = () => {
    console.log("render again");
    if (!isWaiting) {
      return playListList;
    } else {
      return <Waiting />;
    }
  };

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const handleReplacePlayList = () => {
    setIsAutoPlayOn(true);
    IntervalService.clearAllIntervals();
    setCurrentPlayList(sessionToken, chosenPlayList);
    handleCloseChangePlayList();
  };

  const handleAddPlayListToEnd = () => {
    setIsAutoPlayOn(true);
    if (playQueue) {
      if (playQueue.items.length == 0) {
        IntervalService.clearAllIntervals();
      }
    }
    addPlayListToTheEnd(sessionToken, chosenPlayList);
    handleCloseChangePlayList();
  };

  const saveScrollTop = (scrollTop) => {
    if (!isDialogClosing) {
      sessionStorage.setItem(muvikaAttrs.service + "-playlists-scrolltop", scrollTop);
    }
    setIsDialogClosing(false);
  };

  const renderNewPlayListButton = () => {
    if (settingsUsageMode) {
      if (settingsUsageMode === "restaurant") {
        return <IconButton className="muvika-button-right" color="white" component="label" onClick={(e) => {

          e.stopPropagation();
          handleOpenAddPlayList();
        }}>
          <AddCircleIcon />
        </IconButton>;
      }
    } else {
      return <IconButton className="muvika-button-right" color="white" component="label" onClick={(e) => {

        e.stopPropagation();
        handleOpenAddPlayList();
      }}>
        <AddCircleIcon />
      </IconButton>;
    }
  };

  const renderContainer = () => {
    console.log("rendering contentcontainer");
    setTimeout(() => scrollToPos(), 100);
    return <ContentContainer id="muvika-playlists" onScroll={(scrollTop) => {
      saveScrollTop(scrollTop);
    }} onScrollDown={() => {
    }} isFinished={true}>
      {waitingRender()}
    </ContentContainer>;
  };

  return (
    <div ref={playlistsRef}>
      <AddPlayList
        open={isAddPlayListOpen}
        onClose={handleCloseAddPlayList}
        onPlayListCreation={handlePlayListCreation}
      />
      <EditPlayList
        open={isEditPlayListOpen}
        playListName={chosenPlayList ? chosenPlayList.name : ""}
        onClose={handleCloseEditPlayList}
        onPlayListEdit={handlePlayListEdit}
      />
      <SavePlayList
        openToLeft={true}
        open={isSavePlayQueueOpen}
        onClose={handleCloseSavePlayQueue}
        onPlayListSave={handlePlayQueueSave}
      />
      <DeleteDialog
        openToLeft={true}
        open={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        onDeletion={handleDeletion}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_delete}
      />
      <Confirm
        openToLeft={true}
        open={isSavePlayListOpen}
        onClose={handleCloseSavePlayList}
        onConfirmation={handleConfirmation}
      />
      <ChangePlayList
        openToLeft={true}
        isEmpty={playQueue ? playQueue.items.length == 0 : false}
        open={isChangePlayListOpen}
        onClose={handleCloseChangePlayList}
        onReplace={handleReplacePlayList}
        onAddToEnd={handleAddPlayListToEnd}
      />
      <Grid container spacing={0}>
        <Grid item xs={11}>
          <h3>{TR.cm_playlists}</h3>
        </Grid>
        <Grid item xs={1}>
          {renderNewPlayListButton()}
        </Grid>
      </Grid>
      {renderContainer()}
    </div>
  );
}

export default PlayLists;